import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  // User info and scoreboard persist after user leaves page
  quizUserInfo: localStorage.getItem('quizUserInfo') ? JSON.parse(localStorage.getItem('quizUserInfo')) : null,

  quizScoreboard: localStorage.getItem('quizScoreboard') ? JSON.parse(localStorage.getItem('quizScoreboard')) : null,
  
  // All other information is refetched on reload, but held in cache while user is on page
  quizGroups: sessionStorage.getItem('quizGroups') ? JSON.parse(sessionStorage.getItem('quizGroups')) : null,

  quizChallenges: sessionStorage.getItem('quizChallenges') ? JSON.parse(sessionStorage.getItem('quizChallenges')) : null,

  quizList: sessionStorage.getItem('quizList') ? JSON.parse(sessionStorage.getItem('quizList')) : null,

  questionFeedback: sessionStorage.getItem('questionFeedback') ? JSON.parse(sessionStorage.getItem('questionFeedback')) : null,

  generalFeedback: sessionStorage.getItem('generalFeedback') ? JSON.parse(sessionStorage.getItem('generalFeedback')) : null,

  // Live game
  quizLiveGame: sessionStorage.getItem('quizLiveGame') ? JSON.parse(sessionStorage.getItem('quizLiveGame')) : null,
};

const quizAuthSlice = createSlice({
  name: 'quizAuth',
  initialState,
  reducers: {
    setQuizCredentials: (state, action) => {
      state.quizUserInfo = action.payload;
      localStorage.setItem('quizUserInfo', JSON.stringify(action.payload));
    },
    setQuizGroups: (state, action) => {
      state.quizGroups = action.payload;
      sessionStorage.setItem('quizGroups', JSON.stringify(action.payload));
    },
    setQuizChallenges: (state, action) => {
      state.quizChallenges = action.payload;
      sessionStorage.setItem('quizChallenges', JSON.stringify(action.payload));
    },
    setQuizList: (state, action) => {
      state.quizList = action.payload;
      sessionStorage.setItem('quizList', JSON.stringify(action.payload));
    },
    setQuizScoreboard: (state, action) => {
      state.quizScoreboard = action.payload;
      localStorage.setItem('quizScoreboard', JSON.stringify(action.payload));
    },
    setQuestionFeedback: (state, action) => {
      state.questionFeedback = action.payload;
      sessionStorage.setItem('questionFeedback', JSON.stringify(action.payload));
    },
    setGeneralFeedback: (state, action) => {
      state.generalFeedback = action.payload;
      sessionStorage.setItem('generalFeedback', JSON.stringify(action.payload));
    },
    setQuizLiveGame: (state, action) => {
      state.quizLiveGame = action.payload;
      sessionStorage.setItem('quizLiveGame', JSON.stringify(action.payload));
    },
    quizLogout: (state) => {
      state.quizUserInfo = null;
      state.quizGroups = null;
      state.quizChallenges = null;
      state.quizList = null;
      state.quizScoreboard = null;
      state.questionFeedback = null;
      state.generalFeedback = null;
      state.quizLiveGame = null;
      localStorage.removeItem('quizUserInfo');
      localStorage.removeItem('quizScoreboard');sessionStorage.removeItem('quizGroups');
      sessionStorage.removeItem('quizChallenges');
      sessionStorage.removeItem('quizList');
      sessionStorage.removeItem('questionFeedback');
      sessionStorage.removeItem('quizLiveGame');
    },
  },
});

export const {
  setQuizCredentials,
  setQuizGroups,
  setQuizChallenges,
  setQuizScoreboard,
  setQuizList,
  quizLogout,
  setGeneralFeedback,
  setQuestionFeedback,
  setQuizLiveGame,
} = quizAuthSlice.actions;

export default quizAuthSlice.reducer;
